import React from 'react';
import { FlowsQuestion } from '../../../../types/FlowsTypes';

import TextInputComponent from './TextInputComponent';

interface Props {
  question: FlowsQuestion;
}

const TextInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  switch (null) {
    default:
      return <TextInputComponent question={question} />;
  }
};

export default TextInputPicker;
